import React, { useEffect } from 'react'
import { useDispatch, useSelector, connect } from 'react-redux'
import { setAuthInfo } from '../../redux/actions/authActions'
import { history } from '../history'
import HeaderImage from '../../img/programmers-header-reverse.svg'
import FooterImage from '../../img/programmers-footer.svg'
import { Container } from '@material-ui/core'
import { Helmet } from 'react-helmet'


const Dashboard = ({ fullName }) => {
    useEffect(() => {
        window.scrollTo(0, 0)
    })

    return (
        <>
            <Helmet>
                <title>منم ، هویت دیجیتالی تو - پنل کاربری</title>
            </Helmet>

            <main id='dashboard'>
                <header id='section-1'>
                    <img src={HeaderImage} alt='' />
                </header>

                <Container maxWidth='lg'>
                    <section id='dashboard-form' style={
                        {
                            height: '50vh',
                            padding: '6em 0',
                            textAlign: 'right'
                        }
                    }>
                        <h4 id='fullname'>{fullName} عزیز</h4>
                        <h5>به پنل کاربری منم خوش آمدید</h5>
                        <p>از طریق فرم زیر میتوانید اطلاعات خود را وارد یا اقدام به ویرایش آنها نمایید</p>

                        <section style={
                            {
                                textAlign: 'center',
                                margin: '7em 0'
                            }
                        }>
                            <h1>پنل کاربری در حال ساخت می باشد</h1>
                        </section>
                    </section>
                </Container>

            </main>
        </>
    )
}

const mapStateToProps = (state) => ({
    fullName: state.authInfo.fullname
})

export default connect(mapStateToProps)(Dashboard)